import { useState, useEffect } from "react";
import { ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "./firebase";
import "./App.css";
import { Link } from "react-router-dom";

function App() {
  const [name, setName] = useState("");
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progressMap, setProgressMap] = useState({});
  const [dialogMessage, setDialogMessage] = useState("");
  const [showNamePrompt, setShowNamePrompt] = useState(true);

  useEffect(() => {
    document.title = "Christa & Dan's Wedding Album";

    const savedName = localStorage.getItem("guestName");
    if (savedName) {
      setName(savedName);
      setShowNamePrompt(false);
    }
  }, []);

  const handleNameSubmit = () => {
    if (name.trim()) {
      localStorage.setItem("guestName", name.trim());
      setShowNamePrompt(false);
    }
  };

  const handleUpload = async () => {
    if (!files.length || !name) return;

    setUploading(true);
    let successCount = 0;

    for (const file of files) {
      const fileRef = ref(storage, `wedding-uploads/${name}/${Date.now()}-${file.name}`);
      const uploadTask = uploadBytesResumable(fileRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setProgressMap((prev) => ({ ...prev, [file.name]: percent }));
        },
        (error) => {
          console.error(`Upload error for ${file.name}`, error);
        },
        () => {
          successCount++;
        }
      );

      await new Promise((resolve) => uploadTask.on("state_changed", null, null, resolve));
    }

    setDialogMessage(`✅ Uploaded ${successCount} file${successCount !== 1 ? "s" : ""} successfully!`);
    setUploading(false);
    setFiles([]);
    setProgressMap({});
  };

  const handleFileChange = (e) => {
    const selected = [...e.target.files];
    setFiles(selected);
    setProgressMap({});
  };

  const handleRemoveFile = (fileToRemove) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    setProgressMap((prev) => {
      const updated = { ...prev };
      delete updated[fileToRemove.name];
      return updated;
    });
  };


  return (
    <div className="app">
      <h1>Share the Joy!</h1>
      <p>Upload your photos here to help us celebrate.</p>
      {showNamePrompt && (
        <div className="modal">
          <div className="modal-content">
            <h2>Welcome!</h2>
            <p>Please enter your name to upload photos:</p>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your Name"
            />
            <button onClick={handleNameSubmit} disabled={!name.trim()}>
              Continue
            </button>
          </div>
        </div>
      )}

      {!showNamePrompt && (
        <>
          <label className="upload-label">
            {files.length
              ? `${files.length} file${files.length !== 1 ? "s" : ""} selected`
              : "Choose photos"}
            <input type="file" accept="image/*" multiple onChange={handleFileChange} />
          </label>

          <div className="previews">
            {files.map((file) => (
              <div key={file.name} className="preview">
                <div className="image-container">
                  <img src={URL.createObjectURL(file)} alt={file.name} />
                  {!uploading && (
                    <button className="remove-btn" onClick={() => handleRemoveFile(file)}>
                      ×
                    </button>
                  )}
                </div>
                {uploading && (
                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${progressMap[file.name] || 0}%` }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>


          <button onClick={handleUpload} disabled={!files.length || uploading} className="upload-button">
            {uploading ? "Uploading..." : "Upload Photos"}
          </button>
          <Link to="/gallery" className="gallery-link">View Gallery →</Link>
        </>
      )}

      {dialogMessage && (
        <div className="dialog">
          <p>{dialogMessage}</p>
          <button onClick={() => setDialogMessage("")}>Close</button>
        </div>
      )}
    </div>
  );
}

export default App;
